/* eslint-disable sonarjs/no-duplicate-string */
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject, of, throwError } from 'rxjs';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SubMenuNavService {
  subMenuClickedSubject = new Subject<string>();
  menuClickedSubject = new BehaviorSubject<boolean>(false);
  apiUrl: string;
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);
  constructor(
    private _http: HttpClient,
    private _gw: AppStateGateway,
    private featureTogglesFacade: FeatureTogglesFacade,
    private translate: TranslateService,
  ) {}

  redirectToExtUrl(extUrl: string, target: string) {
    this.isOktaLoginEnabled$
      .pipe(take(1))
      .subscribe((isOktaLoginEnabled: boolean) => {
        const isOktaExtRedirectUrl = this.translate.instant(
          `global.isOktaExtRedirectUrl`,
        );
        if (isOktaLoginEnabled && isOktaExtRedirectUrl === 'true') {
          const oktaExtRedirect = this._gw.getOktaExtRedirect(extUrl);
          window.open(oktaExtRedirect, target);
        } else {
          window.open(extUrl, target);
        }
      });
  }
  getBrokerQuoteMedical(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getBrokerQuoteMedical()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_blank');
  }
  getIfpMedicalAgency() {
    this.apiUrl = this._gw.getIfpMedicalAgency();

    this.redirectToExtUrl(this.apiUrl, '_blank');
  }
  getBrokerQuoteDental() {
    this.apiUrl = this._gw.getBrokerQuoteDental();
    this.redirectToExtUrl(this.apiUrl, '_self');
  }
  getBrokerQuoteDentalAdmin(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getBrokerQuoteDentalAdmin()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_self');
  }
  getIfpMedicalAdmin(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getIfpMedicalAdmin()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_blank');
  }

  getIfpMedicalExtAgent() {
    this.apiUrl = this._gw.getIfpMedicalExtAgent();
    this.redirectToExtUrl(this.apiUrl, '_blank');
  }
  getUserSession(
    roleId: string,
    brokerId: string,
  ): Observable<ValidationResponse> {
    this.apiUrl = this._gw.getUserSession();

    const requestPayload = {
      roleId: `${roleId}`,
      brokerId: `${brokerId}`,
    };

    return this._http.post<ValidationResponse>(this.apiUrl, requestPayload);
  }

  getBrokerBobPlans(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getBrokerBobPlans()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_blank');
  }
  getBrokerQuoteAdvantage2022() {
    this.redirectToExtUrl(this._gw.getBrokerQuoteAdvantage2022(), '_blank');
  }

  getBrokerQuoteAdvantage2023() {
    this.redirectToExtUrl(this._gw.getBrokerQuoteAdvantage2023(), '_blank');
  }

  publishSubMenuCLicked(submenuItem: string) {
    this.subMenuClickedSubject.next(submenuItem);
  }
}

export interface Roles {
  entitlements?: string[] | undefined;
  roleId: string;
  brokerId: string;
  lob?: string;
  producerCode: string;
  isContractValid?: boolean;
}

export interface ValidationResponse {
  data?: [];
  metadata?: Metadata;
}

export interface Metadata {
  serviceReferenceId?: string;
  outcome?: Outcome;
}

export interface Outcome {
  status: number;
  message: string;
  type?: string;
  code: number;
  additionalDetails?: [];
}
